// ThemeToggle.js
import React from 'react';
import { useThemeMode } from './ThemeContext';
import { IconButton, Tooltip } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTranslation } from 'react-i18next';

const ThemeToggle = () => {
    const { mode, toggleColorMode } = useThemeMode();
    const { t } = useTranslation();

    return (
        <Tooltip
            title={mode === 'dark'
                ? t('switch_to_light_mode', 'Switch to light mode')
                : t('switch_to_dark_mode', 'Switch to dark mode')}
            arrow
        >
            <IconButton onClick={toggleColorMode} color="inherit">
                {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        </Tooltip>
    );
};

export default ThemeToggle;
